import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';

import TkField from '@/../bower_components/teknisavuecomponents/components/fields/TkField.vue';
import TkFile from '@/../bower_components/teknisavuecomponents/components/document/TkFile/TkFile.vue';
import TkToolbar from '@/../bower_components/teknisavuecomponents/components/grids/TkToolbar.vue';
import DocumentosDetalhes from '@/components/documentos/DocumentosDetalhes/DocumentosDetalhes.vue';
import NovoDocumentoPopup from '@/components/documentos/NovoDocumentoPopup/NovoDocumentoPopup.vue';

import CommonRequests from '@/assets/ts/controller/CommonRequests';
import DocumentosController from '@/assets/ts/controller/DocumentosController';

import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Periodo';
import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import Periodo from '@/../bower_components/teknisavuecomponents/assets/interfaces/Periodo';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import ToolbarAction from '@/../bower_components/teknisavuecomponents/assets/interfaces/ToolbarAction';
import { ControleAcessoWrapper } from '@/assets/ts/controller/ControleAcessoController';

@Component({
  name: 'Documentos',
  components: {
    TkFile,
    TkField,
    TkToolbar,
    DocumentosDetalhes,
    NovoDocumentoPopup,
  },
})
class Documentos extends Vue {
  // #region [ STORE ]
  private get estruturaGerencialAtual(): Estrutura {
    return this.$store.getters.estruturaGerencialAtual;
  }

  private get periodoDemonstrativoAtual(): Periodo {
    return this.$store.getters.periodoDemonstrativoAtual;
  }

  @Mutation('changeCurrentView')
  private changeCurrentView: (string) => void;
  // #endregion

  // #region [ DATA ]
  private readonly viewTitle = 'Documentos';

  private loading = false;

  private categorias = [];

  private vinculos = [];
  private loadingVinculos = false;
  private nrVinculo = '';

  private detalhesPopup = {
    show: false,
    nrCategoria: '',
    nmCategoria: '',
    triggerReload: 0,
  };

  private novoDocPopup = {
    show: false,
    nrCategoria: '',
  };
  // #endregion

  // #region [ COMPUTED ]
  private get vinculoField() {
    const field: Field = {
      name: 'NRVINCULOM',
      label: this.vinculoFieldLabel,
      type: 'autocomplete',
      items: this.vinculos,
      descriptionField: 'NMVINCULOM',
      valueField: 'NRVINCULOM',
      loading: this.loadingVinculos,
      readonly: this.loadingVinculos,
    };

    return field;
  }

  private get vinculoFieldLabel(): string {
    const label = this.loadingVinculos ?
      'Carregando...' :
      'Vínculo';

    return label;
  }

  private get textoNenhumDocumento(): string {
    if (this.nrVinculo === '') {
      return 'Selecione um vínculo para ver seus documentos.';
    }

    if (this.loading) {
      return 'Carregando...';
    }

    return 'Nenhum documento foi encontrado.';
  }

  private get filtersAreSet(): boolean {
    const areSet =
      this.estruturaGerencialAtual !== undefined &&
      this.periodoDemonstrativoAtual.NRPERIODOAPURACAO !== undefined &&
      this.nrVinculo !== '';

    return areSet;
  }

  private get toolbarActions(): ToolbarAction[] {
    const actions = [
      {
        name: 'reload',
        label: 'Atualizar',
        icon: 'mdi-refresh',
        onClick: this.reloadCategorias,
        disabled: this.loading,
      },
      {
        name: 'add',
        label: 'Adicionar',
        icon: 'mdi-plus-circle',
        onClick: ControleAcessoWrapper.criar(this.add),
      },
    ];

    return actions;
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    this.changeCurrentView(this.viewTitle);
    (window as any).documentos = this;
  }

  private mounted() {
    this.reloadVinculos();
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('estruturaGerencialAtual')
  private estruturaGerencialAtualOnChange() {
    this.reloadVinculos();
  }

  @Watch('periodoDemonstrativoAtual')
  private periodoDemonstrativoAtualOnChange() {
    this.reloadVinculos();
  }
  // #endregion

  // #region [ METHODS ]
  private async reloadVinculos() {
    if (!this.periodoDemonstrativoAtual || !this.estruturaGerencialAtual) {
      return;
    }

    this.loadingVinculos = true;

    try {
      this.vinculos = await CommonRequests.getVinculosDoGestor(false);

      // Caso o vínculo selecionado não estaja na nova lista de vínculos
      // carregada, ele será desselecionado
      const vinculoAtualNosVinculos = this.vinculos.some((vinculo) => {
        return vinculo.NRVINCULOM === this.nrVinculo;
      });

      if (!vinculoAtualNosVinculos) {
        this.nrVinculo = '';
      }
    } finally {
      this.loadingVinculos = false;
    }
  }

  private async reloadCategorias() {
    if (!this.verifyFilters()) {
      return;
    }

    this.loading = true;
    this.categorias = [];

    try {
      const categorias = await DocumentosController.getCategoriasComDocumentoVinculo(
        this.nrVinculo, false
      );

      const categoriaNull = categorias.find((categoria) => {
        return categoria.NRCATEGDOCUMENTO === null;
      });

      if (categoriaNull) {
        categoriaNull.NRCATEGDOCUMENTO = 'null';
        categoriaNull.NMCATEGDOCUMENTO = '(Sem Categoria)';
      }

      this.categorias = categorias;
    } finally {
      this.loading = false
    }
  }

  private verifyFilters(): boolean {
    if (!this.filtersAreSet) {
      const message = 'Selecione os filtros necessários!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ALERT);
    }

    return this.filtersAreSet;
  }

  private async add() {
    if (!this.verifyFilters()) {
      return;
    }

    this.novoDocPopup.show = true;
    this.novoDocPopup.nrCategoria = '';
  }

  private openPopupDocumentos(categoria: any) {
    this.detalhesPopup.nrCategoria = categoria.NRCATEGDOCUMENTO;
    this.detalhesPopup.nmCategoria = categoria.NMCATEGDOCUMENTO;
    this.detalhesPopup.show = true;
  }

  private afterSave() {
    this.reloadCategorias();

    if (this.detalhesPopup.show) {
      this.reloadDetalhesPopup();
    }
  }

  private reloadDetalhesPopup() {
    this.detalhesPopup.triggerReload++;
  }

  private detalhesPopupOnAdd() {
    this.novoDocPopup.show = true;
    this.novoDocPopup.nrCategoria = this.detalhesPopup.nrCategoria;
  }
  // #endregion
}

export default Documentos;